






















































































































import Vue from "vue";
import compareVersions from "compare-versions";

// Vuex
import { mapActions, mapState } from "vuex";
import { RootState } from "@/store";
import { GET_AVAILABLE_SOFTWARE_VERSIONS } from "@/store/modules/ApplicationModule/actions";

// Model
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import { GetI18nStringFromUpdateType, UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { ComparisonOperatorEnum, comparisonOperatorEnumLabel } from "@/model/data/enums/ComparisonOperatorEnum";
import { compareSoftwareVersions } from "@/utility/Constants";

class ObfuscatedVersion {
    obfuscatedVersion: string;
    versions: string[] = [];

    constructor(obfuscatedVersion: string, singleVersion: string) {
        this.obfuscatedVersion = obfuscatedVersion;
        this.versions.push(singleVersion);
    }
}

export default Vue.extend({
    data() {
        return {
            isMenuOpen: false,
            swName: null,
            selectedVersion: null,
            selectedVersions: [],
            selectedObfuscatedVersions: [],
            applied: false,
            radioGroup: 3,
            selectedSign: null,
            obfuscatedAvailableItems: new Array<ObfuscatedVersion>(),
            sentVersions: [],
            appliedRadioGroup: 3,
            appliedSelectedVersion: null,
            appliedSelectedVersions: [],
            appliedSelectedObfuscatedVersions: [],
            appliedSelectedSign: null,
        };
    },
    props: ["customAttrs", "button"],
    computed: {
        ...mapState({
            availableSoftwareFilter: (state: RootState): SoftwareFilter[] => state.application.availableSoftwareVersions,
            availableSoftwareVersionsType: (state: RootState): string => state.application.availableSoftwareVersionsType,
        }),

        availableSing() {
            let items = [];
            items.push({ value: ComparisonOperatorEnum.LessThanOrEqualTo, text: this.$t(comparisonOperatorEnumLabel(ComparisonOperatorEnum.LessThanOrEqualTo)) });
            items.push({ value: ComparisonOperatorEnum.GreaterThanOrEqualTo, text: this.$t(comparisonOperatorEnumLabel(ComparisonOperatorEnum.GreaterThanOrEqualTo)) });
            return items;
        },

        filterUpdateType() {
            return this.customAttrs.filterUpdateType;
        },

        filterSwName() {
            return this.customAttrs.filterSwName;
        },

        showOnlyMultipleSelection() {
            return this.customAttrs.showOnlyMultipleSelection ? this.customAttrs.showOnlyMultipleSelection : false;
        },

        label() {
            return this.$t(GetI18nStringFromUpdateType(this.filterUpdateType));
        },

        filterTitle() {
            return (this.filterSwName ? this.filterSwName : this.label) + " " + this.$t("common.filter");
        },

        canDeleteFilters() {
            return this.radioGroup != 3;
        },

        canApply() {
            if (this.sentVersions.length == 0 && this.radioGroup == 3) return false;
            if (this.radioGroup == 0 && this.somethingDifferent) return true;
            if (this.radioGroup == 1 && this.somethingDifferent && this.selectedObfuscatedVersions.length > 0) return true;
            if (this.radioGroup == 2 && this.somethingDifferent) return true;
            if (this.radioGroup == 3 && this.somethingDifferent) return true;
            else return false;
        },

        somethingDifferent() {
            if (this.radioGroup != this.appliedRadioGroup) return true;
            if (this.radioGroup == 0) {
                if (this.appliedSelectedSign.value != this.selectedSign.value) return true;
                if (this.appliedSelectedVersion != this.selectedVersion) return true;
            }
            if (this.radioGroup == 1) {
                if (this.appliedSelectedVersions.length != this.selectedVersions.length) return true;
                for (let element of this.selectedVersions) {
                    if (!this.appliedSelectedVersions.includes(element)) return true;
                }
            }

            return false;
        },

        availableItems() {
            let res = [];
            if (Array.isArray(this.availableSoftwareFilter) && this.availableSoftwareFilter.length)
                if (this.availableSoftwareFilter.some((sw) => sw.updateType == this.filterUpdateType)) {
                    // se sono un sw di terze parti ed ho specificato il nome del sw filtro versionList
                    if (this.filterUpdateType == UpdateTypeEnum.ThirdPartySoftware && this.filterSwName)
                        res = this.availableSoftwareFilter
                            .find((sw) => sw.updateType == this.filterUpdateType)
                            .versionsList.filter((v: NamedSoftwareVersion) => v.name == this.filterSwName);
                    // altrimenti non filtro versionList
                    else res = this.availableSoftwareFilter.find((sw) => sw.updateType == this.filterUpdateType).versionsList;
                    res = res.sort(compareSoftwareVersions);
                }
            return res;
        },
    },
    watch: {
        availableItems() {
            this.setObfuscatedAvailableItems();
        },

        selectedObfuscatedVersions(newValue) {
            this.selectedVersions = [];
            newValue.forEach((version) => {
                this.obfuscatedAvailableItems
                    .filter((ov: ObfuscatedVersion) => ov.obfuscatedVersion == version)[0]
                    .versions.forEach((v) => {
                        this.selectedVersions.push(v);
                    });
            });
        },
    },
    methods: {
        ...mapActions([GET_AVAILABLE_SOFTWARE_VERSIONS]),

        closeMenu() {
            // this.reset();

            this.resetToApplied();
            this.isMenuOpen = false;
        },

        reset() {
            this.swName = null;
            this.radioGroup = 3;
            this.selectedSign = this.availableSing[0];
            this.selectedObfuscatedVersions = [];
            this.selectedVersions = [];
            this.setObfuscatedAvailableItems();
        },

        resetToApplied() {
            if (this.applied) {
                this.radioGroup = this.appliedRadioGroup;
                this.selectedVersion = this.appliedSelectedVersion;
                this.selectedVersions = this.appliedSelectedVersions;
                this.selectedObfuscatedVersions = this.appliedSelectedObfuscatedVersions;
                this.selectedSign = this.appliedSelectedSign;
            }
        },

        setObfuscatedAvailableItems() {
            this.obfuscatedAvailableItems = [];
            if (this.availableItems.length > 0) {
                if (this.filterUpdateType == UpdateTypeEnum.ThirdPartySoftware && this.filterSwName) this.swName = this.filterSwName;
                else this.swName = this.availableItems[0].name;

                this.availableItems.forEach((item) => {
                    let key = VersionObfuscator.obfuscate(item.version.trim());

                    let find = this.obfuscatedAvailableItems.find((v) => v.obfuscatedVersion === key);
                    if (find) find.versions.push(item.version.trim());
                    else this.obfuscatedAvailableItems.push(new ObfuscatedVersion(key, item.version.trim()));
                });
                this.selectedVersion = this.obfuscatedAvailableItems[0].obfuscatedVersion;
            }
        },

        onApply() {
            let itemsToEmit = [];
            switch (this.radioGroup) {
                // <= or >= than
                case 0:
                    // resetto ai valori di default il resto
                    this.selectedObfuscatedVersions = [];
                    this.selectedVersions = [];

                    // calcolo le versioni da mandare
                    switch (this.selectedSign.value as ComparisonOperatorEnum) {
                        case ComparisonOperatorEnum.LessThanOrEqualTo:
                            this.obfuscatedAvailableItems.forEach((ov: ObfuscatedVersion) => {
                                if (compareVersions.compare(ov.obfuscatedVersion, this.selectedVersion, "<=")) {
                                    ov.versions.forEach((v) => {
                                        let c = { name: this.swName, version: v };
                                        itemsToEmit.push(c);
                                    });
                                }
                            });
                            break;
                        case ComparisonOperatorEnum.GreaterThanOrEqualTo:
                            this.obfuscatedAvailableItems.forEach((ov: ObfuscatedVersion) => {
                                if (compareVersions.compare(ov.obfuscatedVersion, this.selectedVersion, ">=")) {
                                    ov.versions.forEach((v) => {
                                        let c = { name: this.swName, version: v };
                                        itemsToEmit.push(c);
                                    });
                                }
                            });
                            break;
                        default:
                            break;
                    }

                    break;
                // custom selection
                case 1:
                    // resetto ai valori di default il resto
                    this.selectedSign = this.availableSing[0];
                    if (this.obfuscatedAvailableItems != null && this.obfuscatedAvailableItems.length > 0)
                        this.selectedVersion = this.obfuscatedAvailableItems[0].obfuscatedVersion;
                    else this.selectedVersion = null;

                    // calcolo le versioni da mandare
                    this.selectedVersions.forEach((v) => {
                        let c = { name: this.swName, version: v };
                        itemsToEmit.push(c);
                    });
                    break;
                // without software
                case 2:
                    itemsToEmit = [{ name: this.swName, version: "-" }];
                    break;
                default:
                    // resetto ai valori di default il resto
                    this.selectedObfuscatedVersions = [];
                    this.selectedVersions = [];
                    this.selectedSign = this.availableSing[0];
                    if (this.obfuscatedAvailableItems != null && this.obfuscatedAvailableItems.length > 0)
                        this.selectedVersion = this.obfuscatedAvailableItems[0].obfuscatedVersion;
                    else this.selectedVersion = null;
                    break;
            }
            this.$emit("input", itemsToEmit);

            this.sentVersions = Object.assign(
                [],
                itemsToEmit.map((item) => item.version)
            );

            this.isMenuOpen = false;
            this.appliedRadioGroup = this.radioGroup;
            this.appliedSelectedVersion = this.selectedVersion;
            this.appliedSelectedVersions = this.selectedVersions;
            this.appliedSelectedObfuscatedVersions = this.selectedObfuscatedVersions;
            this.appliedSelectedSign = this.selectedSign;
            this.applied = true;
        },
    },
    async mounted() {
        if (!this.customAttrs.versionType) this.customAttrs.versionType = "update";
        if (!this.availableSoftwareFilter || !this.availableSoftwareFilter.length || this.availableSoftwareVersionsType != this.customAttrs.versionType)
            await this[GET_AVAILABLE_SOFTWARE_VERSIONS](this.customAttrs.versionType);
        this.sentVersions = [];
        this.reset();
    },
});
